import {formatPercentage} from '@eitje/web_components/src/components/graph/helpers'

const formatCompactPercentage = value => formatPercentage(Math.round(value))

export const graphVariantsTaxonomy = [
	{
		name: 'created',
	},
	{
		name: 'signed',
	},
	{
		name: 'signed_pct',
		fullFormatFn: formatPercentage,
		compactFormatFn: formatCompactPercentage,
	},
	{
		name: 'five_users_pct',
		fullFormatFn: formatPercentage,
		compactFormatFn: formatCompactPercentage,
	},
	{
		name: 'five_tokens_pct',
		fullFormatFn: formatPercentage,
		compactFormatFn: formatCompactPercentage,
	},
	{
		name: 'five_shifts_pct',
		fullFormatFn: formatPercentage,
		compactFormatFn: formatCompactPercentage,
	},
	{
		name: 'five_published_shifts_pct',
		fullFormatFn: formatPercentage,
		compactFormatFn: formatCompactPercentage,
	},
]
